import { useRef, useEffect, useState } from 'react';

/**
 * This hook is used to measure the width of items within the supplied
 * container. Each measurable item must have a `data-measure={key}` attribute.
 */
export const useMeasureChildrenWidth = <T extends HTMLDivElement>() => {
  const measureRef = useRef<T>(null);
  const [widths, setWidths] = useState<Record<string, number>>({});

  useEffect(() => {
    if (!measureRef.current) return;

    const measure = () => {
      if (!measureRef.current) return;
      const buttons = Array.from(
        measureRef.current.querySelectorAll<HTMLButtonElement>(
          'button[data-measure]'
        )
      );
      const width = {} as Record<string, number>;
      for (const button of buttons) {
        const key = button.getAttribute('data-measure') as string;
        width[key] = button.getBoundingClientRect().width;
      }
      setWidths(width);
    };

    const observer = new ResizeObserver(measure);
    observer.observe(measureRef.current);

    measure();

    return () => observer.disconnect();
  }, []);

  return { widths, measureRef };
};
